import { Injectable } from '@angular/core'
import {
    DealConfigurationQuery,
    DealConfigurationGQL,
    DealOfferQuery,
    DealOfferGQL,
    DealContractQuery,
    DealContractGQL,
    DealContractPdfGQL,
    DealContractPdfQuery,
} from '../../../generated/graphql'
import { pluck } from 'rxjs/operators'
import { ApolloQueryResult } from '@apollo/client/core'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class DealQueryService {
    constructor(
        private dealConfigurationGQL: DealConfigurationGQL,
        private dealOfferGQL: DealOfferGQL,
        private dealContractGQL: DealContractGQL,
        private dealContractPdfGQL: DealContractPdfGQL
    ) {}

    // Queries to fetch a deal while in the configuration stage

    fetchDealConfiguration(id: string): Observable<DealConfigurationQuery['Deal']> {
        return this.dealConfigurationGQL
            .fetch({ id })
            .pipe(pluck<ApolloQueryResult<DealConfigurationQuery>, DealConfigurationQuery['Deal']>('data', 'Deal'))
    }

    watchDealConfiguration(id: string): Observable<DealConfigurationQuery['Deal']> {
        return this.dealConfigurationGQL
            .watch({ id })
            .valueChanges.pipe(
                pluck<ApolloQueryResult<DealConfigurationQuery>, DealConfigurationQuery['Deal']>('data', 'Deal')
            )
    }

    // Queries to fetch a deal while in the offer screen stage

    fetchDealOffer(id: string): Observable<DealOfferQuery['Deal']> {
        return this.dealOfferGQL
            .fetch({ id })
            .pipe(pluck<ApolloQueryResult<DealOfferQuery>, DealOfferQuery['Deal']>('data', 'Deal'))
    }

    watchDealOffer(id: string): Observable<DealOfferQuery['Deal']> {
        return this.dealOfferGQL
            .watch({ id })
            .valueChanges.pipe(pluck<ApolloQueryResult<DealOfferQuery>, DealOfferQuery['Deal']>('data', 'Deal'))
    }

    // Queries to fetch a deal while in the contract stage

    fetchDealContract(id: string): Observable<DealContractQuery['Deal']> {
        return this.dealContractGQL
            .fetch({ id })
            .pipe(pluck<ApolloQueryResult<DealContractQuery>, DealContractQuery['Deal']>('data', 'Deal'))
    }

    watchDealContract(id: string): Observable<DealContractQuery['Deal']> {
        return this.dealContractGQL
            .watch({ id })
            .valueChanges.pipe(pluck<ApolloQueryResult<DealContractQuery>, DealContractQuery['Deal']>('data', 'Deal'))
    }

    // Other queries

    fetchDealContractPdf(dealId: string): Observable<DealContractPdfQuery['DealContractPdf']> {
        return this.dealContractPdfGQL
            .watch({ dealId }, { fetchPolicy: 'no-cache' })
            .valueChanges.pipe(
                pluck<ApolloQueryResult<DealContractPdfQuery>, DealContractPdfQuery['DealContractPdf']>(
                    'data',
                    'DealContractPdf'
                )
            )
    }
}
